import { useEffect, useState } from 'react';

/**
 * Returns the id of the section currently closest to the top of the viewport,
 * so the nav can highlight where the visitor actually is.
 */
export default function useScrollSpy(ids, offset = 120) {
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    const sections = ids
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (!sections.length) return undefined;

    let frame = null;

    const measure = () => {
      frame = null;
      let current = null;

      sections.forEach((section) => {
        if (section.getBoundingClientRect().top - offset <= 0) current = section.id;
      });

      // Bottom of the page always belongs to the last section.
      const atBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 4;
      if (atBottom) current = sections[sections.length - 1].id;

      setActiveId(current);
    };

    const onScroll = () => {
      if (frame === null) frame = window.requestAnimationFrame(measure);
    };

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, [ids, offset]);

  return activeId;
}
